export default __webpack_public_path__ + "static/media/community_iso_01.871f25e8.png";